module.exports = __webpack_public_path__ + "img/email.249117ac.svg";